import React from 'react';
import '../style/About.scss';

const About = () => {
  return (
    <section className="about-container">
      <h2>About Us</h2>
      <p>
        Welcome to our website! We are a passionate team dedicated to delivering
        high-quality products and services.
      </p>
      <p>
        Welcome to Knowledge Hub, a simple place made for learning and discovery. Our goal is to help people find knowledge easily and grow their understanding step by step. Right now, you can search and explore books by name, and in the future, podcasts and articles will be added to make learning more engaging.
This platform is for anyone who is curious and wants to learn at their own pace. We believe knowledge should be easy to access and easy to understand. Join Knowledge Hub and start your learning journey in a simple and meaningful way.
Also I like to say that this Is my first project which I made 2 years before while learning MERN stack. It took me a month to make this website and after 2 years I realised that I should deploy it so Boom! here is Knowledge Hub for you ,I hope you will like it, Thanks for visiting.
      </p>
    </section>
  );
};

export default About;



